var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('com-screen',{class:{'is-mobile': _vm.window.is.mobile, 'is-tablet': _vm.window.is.tablet},attrs:{"id":"app","loading":_vm.is.loading}},[_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }